import View from "./view";
import Presenter from "./presenter";
import { ConnectComponent } from "util";

const states = [
  {
    name: "app.management.customer-sales-report",
    url: "/vendas-por-cliente",
    views: {
      "content@app": ConnectComponent(View, Presenter)
    },
    data: {
      navigation: {
        name: "Vendas por Cliente",
        priority: 400,
        // authorization: (context => context.user.permissions.includes('view_closed_sales')),
        state: "app.management.customer-sales-report"
      }
    }
  }
];

export { states };



// WEBPACK FOOTER //
// ./src/components/app/management/customer-sales-report/index.js